
(function(template){
define('vue!modeSelector/components/container',['Vue','vuex','vue!./GuestSelectComponent','vue!basicComponents/messageContainer'],function(Vue,vuex,GuestSelectComponent,messageContainer){
    return {
        name: 'modeSelector',
        template: template,
        components: {
            'login-component' : GuestSelectComponent,
            'message-container' : messageContainer
        },
        computed: vuex.mapState(['loggedInUser','users']),
        methods: {
            handleYourselfClick: function(){
                if (!app.data.store) app.datal('store', {});
                if (!app.data.store.WebFolioId || app.data.store.WebFolioId != app.data.WebFolioId) app.datal('store', {
                    WebFolioId: app.data.WebFolioId,
                });
                app.datal('store', _.extend(app.data.store, {
                    groupMembersSelected: true
                }));
                this.goNext();
            }
        },
        mounted: function(){
            if(app.data.userLoggedIn){
                if(!this.users[app.data.CustomerId]) this.$store.commit('setLoggedInUser',{userId:app.data.CustomerId});
            }
        }
    }
})
})('<div class="modeSelector"> <message-container></message-container> <div class="segment"> <div class="segment-header yellowHeader">{{localization.spaBooking.packageBooking.modeSelector.header}}</div> <div class="segment-body"> <div class="segment bookingModeHeaders"> <button class="segment-header greyHeader btn btn-primary focus-first" @click="handleYourselfClick">{{localization.spaBooking.packageBooking.modeSelector.individualBookingText}}</button> </div> <login-component></login-component> </div> </div> </div>');
